
import request from '@/utils/request';

export const getTypeList = (params: any) =>
  request({
    url: 'WorkTime/typeList',
    method: 'get',
    params
  });
export const addWorkTime = (data: any) =>
  request({
    url: 'WorkTime/type',
    method: 'POST',
    data
  });

export const deleteWorkTime = (data: any) =>
  request({
    url: 'WorkTime/type',
    method: 'DELETE',
    data
  });

export const editWorkTime = (data: any) =>
  request({
    url: 'WorkTime/type',
    method: 'PUT',
    data
  });
